// removed by extract-text-webpack-plugin
module.exports = {"account":"_2Tb3zw3KBFNLfX-r9klJ8l","accountRight":"_1shcJ0yQ7U2JLfDA9q1cZR","accountSidebar":"_1KJKY9a08mF6n0mmgp_-8W","avtName":"utl97Zuw3xdKPEXapsJTc","name":"v-kJ9SjFQ-8RmWq3G72Lg","sidebarNav":"_1phAh-HFZ2CIHXLI12psRO","active":"_1ZacxMXRsfwgjMn0yGCccN"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Account/Account.scss
// module id = 1168
// module chunks = 0